import type { RestaurantEventAddOn } from '@shared/types/restaurantEvents';

/** An add-on without tiers is offered with every tier. */
export const isAddOnAvailableForTier = (
  addOn: RestaurantEventAddOn,
  tierId: string,
): boolean => {
  const tiers = addOn.tiers ?? [];
  return tiers.length === 0 || tiers.some((tier) => tier.id === tierId);
};
